import firebase from "firebase";
import { firestoreDB } from "../../utils/firebase";
import { CLIENT_ID, CLIENT_EMAIL } from "../../utils/config";
import dayjs from "dayjs";
import { GET_CART, GET_ALL_CLIENT_CART_DATA } from "./actionTypes";
import { showNotifaction, showMessageModal } from "./miscActions";

export const getAllCartData = () => (dispatch) => {
  firestoreDB
    .collection("carts")
    .where("store", "==", CLIENT_ID)
    .onSnapshot(function (querySnapshot) {
      let carts = [];
      querySnapshot.forEach(function (doc) {
        const cart = doc.data();
        cart.id = doc.id;
        carts.push(cart);
      });
      dispatch({
        type: GET_ALL_CLIENT_CART_DATA,
        payload: carts,
      });
    });
};

export const getCartData = (id) => (dispatch) => {
  const docId = id.toString().concat(CLIENT_ID);
  firestoreDB
    .collection("carts")
    .doc(docId)
    .onSnapshot(function (doc) {
      dispatch({
        type: GET_CART,
        payload: doc.data(),
      });
    });
};

export const addToCart =
  (id, quantity, userID, name, btn, history) => (dispatch) => {
    const product = { id, quantity };
    const docId = userID.toString().concat(CLIENT_ID);
    firestoreDB
      .collection("carts")
      .doc(docId)
      .update({
        [product.id]: product,
        store: CLIENT_ID,
        owner: userID,
      })
      .then(function () {
        dispatch(
          showNotifaction(
            "success",
            name,
            "toegevoegd aan winkel wagen",
            btn,
            history
          )
        );
      })
      .catch(function (error) {
        const { message } = error;
        if (
          message.includes("No document to update") ||
          message.includes("Requested entity was not found")
        ) {
          firestoreDB
            .collection("carts")
            .doc(docId)
            .set({
              [id]: product,
              store: CLIENT_ID,
              owner: userID,
            })
            .then(function () {
              dispatch(
                showNotifaction(
                  "success",
                  name,
                  "toegevoegd aan winkelwagen",
                  btn,
                  history
                )
              );
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      });
  };

export const removeFromCart = (id, userID) => (dispatch) => {
  const docId = userID.toString().concat(CLIENT_ID);
  firestoreDB
    .collection("carts")
    .doc(docId)
    .update({
      [id]: firebase.firestore.FieldValue.delete(),
    });
};

export const increaseQuantity = (item, uid) => (dispatch) => {
  const docId = uid.toString().concat(CLIENT_ID);
  const { id, quantity } = item;
  const productRef = firestoreDB.collection("carts").doc(docId);
  productRef.update({ [id]: { id: item.id, quantity: quantity + 1 } });
};

export const decreaseQuantity = (item, uid) => (dispatch) => {
  const docId = uid.toString().concat(CLIENT_ID);
  const { id, quantity } = item;
  const productRef = firestoreDB.collection("carts").doc(docId);
  productRef.update({ [id]: { id: item.id, quantity: quantity - 1 } });
};

export const placeOrder =
  (cart, cost, cust, orderNumber, user, deliveryCost) => (dispatch) => {
    const feedback = {
      type: "loading",
      txt: "Uw bestelling aan het plaatsen",
    };
    dispatch(showMessageModal(feedback));
    const { name, email, adress, houseNum, phone, message, regio } = cust;
    const cats = ["groenten", "fruit", "sap", "aardvrucht", "specerijen"];
    const emailBody = `
  <!DOCTYPE html>
  <html>
  <head>
  <meta name="viewport" content="width=device-width" />
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
    <style>
      body{
        font-family: sans-serif;
        padding: 20px;
      }

      img{
        max-width: 50px;
        padding: 0px 0px 5px 0px;
        margin: 0px;
        height: auto;
      }

      .image-wrapper{
        max-width: 50px;
        height: auto;
      }

      p{
        margin: 0px 0px 8px 0px;
        padding: 0px;
      }
    </style>
  </head>
  <body>
  <h2>New order</h2>
  <br/>
  <h3>Order details</h3>
    <p>Order#: ${orderNumber}</p>
    <p>Datum bestelling: ${dayjs().format("DD - MMM - YYYY")}</p>
    <p>Totaal producten: ${new Intl.NumberFormat("nl-NL", {
      style: "currency",
      currency: "SRD",
    }).format(`${cost}`)}</p>
    <p>Leverkosten: ${
      regio === "PBM"
        ? new Intl.NumberFormat("nl-NL", {
            style: "currency",
            currency: "SRD",
          }).format(`${deliveryCost}`)
        : "-"
    }</p>
    <p>Order Total: ${
      regio === "PBM"
        ? new Intl.NumberFormat("nl-NL", {
            style: "currency",
            currency: "SRD",
          }).format(`${cost + deliveryCost}`)
        : new Intl.NumberFormat("nl-NL", {
            style: "currency",
            currency: "SRD",
          }).format(`${cost}`)
    }</p>
            
    <h3>Shipping Address</h3>
    <p>${adress} #${houseNum}</p>
    <p>${
      regio === "PBM"
        ? "Paramaribo"
        : regio === "CM"
        ? "Commewijne"
        : regio === "BR"
        ? "Brokopondo"
        : regio === "WN"
        ? "Wanica"
        : regio === "PR"
        ? "Para"
        : "Buurt niet aangegeven"
    }</p>
    <p>${message}</p>

    <h3>Contact details</h3>
    <p>${name}</p>
    <p>Email: ${email}</p>
    <p>Phone: ${phone}</p>
    
    <h3>Order</h3>
    ${cart.map((x) => {
      return `
    <div className="image-wrapper">
    <img src=${x.productImage} alt="" width="80"/>
    </div>
    <p><strong>${
      x.productCategorie === "pakket" ? x.pakketNaam : x.productNaam
    }</strong></p>
    <p>Quantity: ${x.quantity} </p> 
    <p>Price per item:  SRD ${
      cats.includes(x.productCategorie.toString()) && x.productOnSale
        ? x.itemSalesPrice
        : x.itemPrice
    }</p>
    <p>Total: SRD ${
      cats.includes(x.productCategorie.toString()) && x.productOnSale
        ? x.itemSalesPrice * x.quantity
        : x.itemPrice * x.quantity
    }</p>
    <br/> <br/>
`;
    })}
  </body>
  </html>
  `;
    firestoreDB
      .collection("orders")
      .add({
        to: CLIENT_EMAIL,
        message: {
          subject: `New order ${orderNumber}`,
          html: emailBody,
        },
        cart,
        store: CLIENT_ID,
        user: user.uid,
        orderNumber,
        orderCost: cost,
        deliveryCost,
        cust,
        status: "pending",
        isArchived: false,
        date: firebase.firestore.FieldValue.serverTimestamp(),
      })
      .then(function (docRef) {
        const response = {
          type: "success",
          txt: `Gelukt! Order# ${orderNumber}`,
        };
        dispatch(showMessageModal(response));
        dispatch(
          emailOrderToClient(cart, cost, cust, orderNumber, user, deliveryCost)
        );
      })
      .catch(function (error) {
        const response = {
          type: "warning",
          txt: `Bestelling plaatsen mislukt. Probeer het later weer opnieuw.`,
        };
        dispatch(showMessageModal(response));
      });
  };

export const emailOrderToClient =
  (cart, cost, cust, orderNumber, user, deliveryCost) => (dispatch) => {
    const { email, adress, houseNum, phone, message, regio } = cust;
    const cats = ["groenten", "fruit", "sap", "aardvrucht", "specerijen"];
    const emailBody = `
  <!DOCTYPE html>
  <html>
  <head>
  <meta name="viewport" content="width=device-width" />
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
    <style>
      body{
        font-family: sans-serif;
        padding: 20px;
      }

      img{
        max-width: 50px;
        padding: 0px 0px 5px 0px;
        margin: 0px;
        height: auto;
      }

      .image-wrapper{
        max-width: 50px;
        height: auto;
      }

      p{
        margin: 0px 0px 8px 0px;
        padding: 0px;
      }
    </style>
  </head>
  <body>
  <h2>Bedankt voor je bestelling</h2>
  <br/>
  <h3>Order details</h3>
    <p>Order#: ${orderNumber}</p>
    <p>Bestel datum: ${dayjs().format("DD - MMM - YYYY")}</p>
    <p>Totaal producten: ${new Intl.NumberFormat("nl-NL", {
      style: "currency",
      currency: "SRD",
    }).format(`${cost}`)}</p>
    <p>Leverkosten: ${
      regio === "PBM"
        ? new Intl.NumberFormat("nl-NL", {
            style: "currency",
            currency: "SRD",
          }).format(`${deliveryCost}`)
        : "worden in overleg bepaald"
    }</p>
    <p>Totaal: ${
      regio === "PBM"
        ? new Intl.NumberFormat("nl-NL", {
            style: "currency",
            currency: "SRD",
          }).format(`${cost + deliveryCost}`)
        : new Intl.NumberFormat("nl-NL", {
            style: "currency",
            currency: "SRD",
          }).format(`${cost}`)
    }</p>
            
    <h3>Shipping Address</h3>
    <p>${adress} #${houseNum}</p>
    <p>${
      regio === "PBM"
        ? "Paramaribo"
        : regio === "CM"
        ? "Commewijne"
        : regio === "BR"
        ? "Brokopondo"
        : regio === "WN"
        ? "Wanica"
        : regio === "PR"
        ? "Para"
        : "Buurt niet aangegeven"
    }</p>
    <p>${message}</p>

    <h3>Contact details</h3>
    <p>Email: ${email}</p>
    <p>Phone: ${phone}</p>
    
    <h3>Bestelling</h3>
    ${cart.map((x) => {
      return `
    <div className="image-wrapper">
    <img src=${x.productImage} alt="" width="80"/>
    </div>
    <p><strong>${
      x.productCategorie === "pakket" ? x.pakketNaam : x.productNaam
    }</strong></p>
    <p>Quantity: ${x.quantity} </p> 
    <p>Price per item:  SRD ${
      cats.includes(x.productCategorie.toString()) && x.productOnSale
        ? x.itemSalesPrice
        : x.itemPrice
    }</p>
    <p>Total: SRD ${
      cats.includes(x.productCategorie.toString()) && x.productOnSale
        ? x.itemSalesPrice * x.quantity
        : x.itemPrice * x.quantity
    }</p>   
    <br/> <br/>
`;
    })}
  </body>
  </html>
  `;

    firestoreDB.collection("messages").add({
      to: email,
      message: {
        subject: `Thank you for your order`,
        html: emailBody,
      },
    });
  };
